import { Dataset } from 'app/containers/PharmacyDataUpdate/constants/dataset'
import axios from 'axios'
import { ApplyPharmacyDataUpdate } from 'types/ApplyPharmacyDataUpdate'
import { PharmacyDataUpdateStatus } from 'types/PharmacyDataUpdateStatus'
import { PharmacyDataUpdateUrl } from 'types/PharmacyDataUpdateUrl'
import { apiv2Client } from './apiv2'

export async function getPharmacyDataUpdateUrl(
  dataset: Dataset,
): Promise<PharmacyDataUpdateUrl> {
  try {
    return await apiv2Client.post<{}, PharmacyDataUpdateUrl>(
      `/admin/files/datasets/${dataset}/upload-url`,
      {},
    )
  } catch (error) {
    throw new Error(
      `Failed to get pharmacy data update url for dataset "${dataset}": ${
        error instanceof Error ? error.message : String(error)
      }`,
    )
  }
}

export async function uploadCsvToS3(
  putUrl: string,
  file: File,
): Promise<boolean> {
  try {
    const response = await axios.put(putUrl, file, {
      headers: {
        'Content-Type': file.type,
      },
    })
    return response.status === 200
  } catch (error) {
    throw new Error(
      `Failed to upload csv to s3 for putUrl "${putUrl}": ${
        error instanceof Error ? error.message : String(error)
      }`,
    )
  }
}

export async function applyPharmacyDataUpdate(
  dataset: Dataset,
  uploadToken?: string,
): Promise<ApplyPharmacyDataUpdate> {
  try {
    return await apiv2Client.post<{}, ApplyPharmacyDataUpdate>(
      `/admin/files/datasets/${dataset}/apply`,
      uploadToken ? { uploadToken } : {},
    )
  } catch (error) {
    throw new Error(
      `Failed to apply pharmacy data update for dataset "${dataset}": ${
        error instanceof Error ? error.message : String(error)
      }`,
    )
  }
}

export async function applyAllPharmacyDataUpdate(): Promise<ApplyPharmacyDataUpdate> {
  try {
    return await apiv2Client.post<{}, ApplyPharmacyDataUpdate>(
      `/admin/files/datasets/apply-all`,
      {},
    )
  } catch (error) {
    throw new Error(
      `Failed to apply all pharmacy data update: ${
        error instanceof Error ? error.message : String(error)
      }`,
    )
  }
}

export async function checkPharmacyDataUpdateStatus(
  jobId: string,
): Promise<PharmacyDataUpdateStatus> {
  try {
    const data = await apiv2Client.get<{}, PharmacyDataUpdateStatus>(
      `/admin/files/jobs/${jobId}/status`,
    )
    return data
  } catch (error) {
    throw new Error(
      `Failed to check pharmacy data update status for job "${jobId}": ${
        error instanceof Error ? error.message : String(error)
      }`,
    )
  }
}
